import { callApiToServer } from "../callApi";

export async function deleteVoucher(authtoken, voucherId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      voucherId: voucherId,
    });

    let endUrl = "v1/auth/voucher";

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
